<template>
  <div class="row justify-center">
    <h1 style="display: none">Privacy policy</h1>
    <div class="col-12 col-sm-10 col-md-9 q-px-sm">
      <Markdown :data="md" class="privacy-text" />
    </div>
  </div>
</template>

<script>
import Markdown from "@/ui/components/Markdown";
import PrivacyPolicy from "@/markdown/PrivacyPolicy.md";
export default {
  components: {
    Markdown,
  },
  data() {
    return {
      md: PrivacyPolicy,
    };
  },
};
</script>

<style scoped>

.privacy-text {
  font-size: 16px;
  line-height: 22px;
  color: #666;
}

</style>
